import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, menu, mobileLogo, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/z1n6s0Q1U12JBeruNx0e/locations/0nBUuNbz0naRmB9PPMgD'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          bg="rgba(213,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          pt="5px"
        >
          <CFView row center>
            <CFImage h="80px" src={mobileLogo} alt="One More SzechuanLogo" />
          </CFView>
          <CFLink href={menu} hover target="_blank">
            <CFImage
              h="70px"
              src={viewMenu}
              alt="One More Szechuan View Menu Button"
            />
          </CFLink>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyStart
          pv="5px"
          bg="rgba(213,0,0,.8)"
          boxShadow="0 2px 5px rgba(0,0,0,.5)"
          zIndex={98}
          w="100%"
        >
          <CFView
            row
            justifyBetween
            alignCenter
            w="100%"
            maxWidth="1400px"
            ph="30px"
          >
            <CFView row center>
              <CFImage
                h="35px"
                ml="35px"
                src={logo}
                alt="One More SzechuanLogo"
                zIndex={98}
              />
            </CFView>
            <CFLink mr="25px" href={menu} hover target="_blank">
              <CFImage
                mt="10px"
                h="65px"
                src={viewMenu}
                alt="One More Szechuan View Menu Button"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
